import * as React from 'react';
import { Field } from 'formik';
import without from 'lodash/without';
import { FormFieldOption } from '../types';

interface CheckboxGroupProps {
  label: string;
  name: string;

  optionsArray: FormFieldOption[];

  selected?: string[]; // Array of selected values
  onChange: (selectedValues: string[]) => void;
}

export default function CheckboxGroup(props: CheckboxGroupProps) {
  const selected = props.selected || [];

  return (
    <fieldset className="checkbox">
      <div className="controls check_boxes form-group">
        {props.label && <label className="control-label">{props.label}</label>}
        <div>
          {props.optionsArray.map(option => (
            <div className="radio" key={option.value}>
              <label className="choice">
                <Field
                  component="input"
                  type="checkbox"
                  name={props.name}
                  value={option.value}
                  checked={selected && selected.includes(option.value)}
                  onChange={e => {
                    if (e.target.checked) {
                      props.onChange([...selected, option.value]);
                    } else {
                      props.onChange(without(selected, option.value));
                    }
                  }}
                />
                {option.displayName}
              </label>
            </div>
          ))}
        </div>
      </div>
    </fieldset>
  );
}
